export default function placeHolderTemplate(content) {
	return `<span class="text-placeholder">${content}</span>`;
}
